export type IncomingLinksSsrStatus = 'present' | 'empty' | 'unavailable';

export type IncomingLinksSsrState = Readonly<{
	contentId: string;
	status: IncomingLinksSsrStatus;
}>;

const isIncomingLinksSsrStatus = (status: unknown): status is IncomingLinksSsrStatus =>
	status === 'present' || status === 'empty' || status === 'unavailable';

export const createIncomingLinksSsrState = (
	contentId: string,
	status: IncomingLinksSsrStatus,
): IncomingLinksSsrState => Object.freeze({ contentId, status });

export const resetIncomingLinksSsrState = (): void => {
	window.__SSR_BYLINE_CONNECTIONS_INBOUND_STATE__ = undefined;
};

export const publishIncomingLinksSsrState = (state: IncomingLinksSsrState): IncomingLinksSsrState =>
	(window.__SSR_BYLINE_CONNECTIONS_INBOUND_STATE__ ??= state);

export const readIncomingLinksSsrState = (contentId: string): IncomingLinksSsrState | undefined => {
	const state = window.__SSR_BYLINE_CONNECTIONS_INBOUND_STATE__;
	if (state?.contentId !== contentId || !isIncomingLinksSsrStatus(state.status)) {
		return undefined;
	}

	return Object.isFrozen(state)
		? state
		: createIncomingLinksSsrState(state.contentId, state.status);
};
